import React, { useState } from 'react';
import './FormularioCargaGas.css';
import { toast } from 'react-toastify';


const FormularioCargaGas = ({ botella, user, onClose }) => {
  const [kgGastado, setKgGastado] = useState('');
  const [cliente, setCliente] = useState('');
  const [fecha, setFecha] = useState(() => new Date().toISOString().slice(0, 10));

  //hay unas variables de entorno que son el archivo .env y el .env.production
  //en el archivo .env.production se encuentran las variables de entorno para producción
  //en el archivo .env se encuentran las variables de entorno para desarrollo
  //esto setea la ruta del servidor dependiendo de si estamos en producción o desarrollo
  const API_URL = process.env.REACT_APP_API_URL || '';

  const handleGuardar = async () => {
    if (!kgGastado || !cliente || !fecha) {
      toast.warn('Todos los campos son obligatorios');
      return;
    }

    const cantidad = parseInt(kgGastado);
    const disponible = botella.kgTotal - botella.kgGastados; // en gramos

    if (cantidad > disponible) {
      toast.error(`No puedes cargar más de ${disponible}g (${(disponible / 100).toFixed(2)}kg)`);
      return;
    }

    const usuario = `${user.nombre} ${user.apellidos}`;

    const payload = {
      idBotella: botella.id,
      kgGastado: cantidad,
      cliente: cliente.slice(0, 25),
      fecha,
      usuario
    };

    try {
      const res = await fetch(`${API_URL}/api/insertar-carga-gas`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const data = await res.json();
      if (data.success) {
        toast.success('Carga registrada correctamente');
        onClose(true); // Recargar tabla
      } else {
        toast.error('Error al registrar la carga');
      }
    } catch (err) {
      console.error('Error al insertar carga:', err);
      toast.error('Error al registrar la carga');
    }
  };

  const kgDisponible = (botella.kgTotal - botella.kgGastados) / 100;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Registrar carga de gas</h3>

        <table className="tabla-detalle-botella">
          <thead>
            <tr>
              <th>ID Botella</th>
              <th>Tipo de Gas</th>
              <th>Disponible</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{botella.id}</td>
              <td>{botella.tipoGas}</td>
              <td>{kgDisponible.toFixed(2)} kg</td>
            </tr>
          </tbody>
        </table>

        <label>Kilos Gastados (en gramos)</label>
        <input
          type="number"
          value={kgGastado}
          onChange={(e) => setKgGastado(e.target.value)}
          placeholder="Ej: 150"
        />

        <label>Cliente</label>
        <input
          type="text"
          maxLength={25}
          value={cliente}
          onChange={(e) => setCliente(e.target.value)}
          placeholder="Nombre del cliente"
        />

        <label>Fecha</label>
        <input
          type="date"
          value={fecha}
          onChange={(e) => setFecha(e.target.value)}
        />

        <div className="modal-actions">
          <button onClick={handleGuardar} className="btn-guardar">Guardar</button>
          <button onClick={() => onClose(false)} className="btn-cancelar">Cancelar</button>
        </div>
      </div>
    </div>
  );
};

export default FormularioCargaGas;
